import React from 'react';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section - Left Aligned */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-bold text-black mb-10 opacity-0 animate-fade-in-up">
            ABOUT US
          </h1>

          <div className="max-w-4xl opacity-0 animate-slide-in-left delay-200">
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              Imperier Holdings is a diversified investment and advisory platform
              operating across multiple verticals, with a focus on long-term
              value creation in the evolving global economy.
            </p>

            <p className="text-xl text-gray-700 leading-relaxed">
              Built as a holding company, Imperier invests, operates, and advises
              across a range of asset classes and business models—spanning
              venture investments, strategic advisory, private opportunities,
              and emerging platforms. Our approach combines disciplined capital
              allocation with deep strategic involvement.
            </p>
          </div>
        </div>
      </section>

      {/* Investment Philosophy - Right Aligned */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto flex justify-end">
          <div className="max-w-4xl opacity-0 animate-slide-in-right">
            <h2 className="text-3xl font-bold text-black mb-8 text-right">
              Our Investment Philosophy
            </h2>

            <div className="space-y-6 text-right">
              <p className="text-lg text-gray-700 leading-relaxed">
                Imperier's philosophy is rooted in long-term thinking, disciplined
                execution, and partnership-driven growth. We prioritise quality
                over quantity, focusing on opportunities that demonstrate clarity
                of vision, strong governance, and the ability to adapt in evolving
                markets.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                We believe that successful investing requires patience and
                conviction, robust due diligence, active engagement beyond
                capital, and strong alignment of incentives between all
                stakeholders.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                Our goal is not short-term optimisation, but durable value creation
                across economic cycles.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Imperier Syndicate - Left Aligned */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl opacity-0 animate-slide-in-left">
            <h2 className="text-3xl font-bold text-black mb-8">
              Imperier Syndicate
            </h2>

            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                Imperier Syndicate is the venture investment arm of Imperier
                Holdings, bringing together a diverse network of family offices,
                angel investors, corporate partners, and strategic capital
                providers.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                The Syndicate model enables collaborative investing—pooling
                capital, expertise, and networks—while offering founders access to
                mentorship, acceleration, and long-term strategic support.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                We are particularly focused on unlocking opportunities in Tier-2
                and Tier-3 markets, where innovation and entrepreneurship are
                rapidly reshaping economic growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision - Right Aligned */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto flex justify-end">
          <div className="max-w-4xl opacity-0 animate-slide-in-right">
            <h2 className="text-3xl font-bold text-black mb-8 text-right">
              Our Vision
            </h2>

            <div className="space-y-6 text-right">
              <p className="text-lg text-gray-700 leading-relaxed">
                Guided by our principle, <span className="font-semibold">Invest Beyond the Obvious</span>,
                Imperier Holdings seeks opportunities that lie beyond conventional
                narratives—businesses, markets, and ideas with the potential to
                redefine industries and generate lasting impact.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                As we continue to expand our platform, Imperier remains committed
                to building a future-ready investment ecosystem grounded in
                integrity, insight, and long-term partnership.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;
